import { Box, Grid, Typography, useTheme } from "@mui/material"
import { AppContext } from "components/AppContextProvider"
import moment from "moment"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { TextCell2 } from "./components/TextCell"

const IoTInfo = ({ vehicleId, iotResult }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const appContext = useContext(AppContext)
  const hasDevices = appContext.appUser.customer.hasDevices
  const todayDate = new Date()
  const yesterdayDate = new Date()
  yesterdayDate.setDate(todayDate.getDate() - 1)
  return (
    hasDevices &&
    iotResult.status === 2 &&
    iotResult.data.ioTLatestUpdated && (
      <Box bgcolor="background.light" padding={3} borderRadius="10px">
        <Typography variant="h4" color={theme.palette.grey[900]} mb={2}>
          {t("vehicleregistry.iot_data", "IoT-data")}
        </Typography>
        <Grid container direction="row" spacing={2}>
          {moment(iotResult.data.ioTLatestUpdated) < moment(yesterdayDate) ? (
            <Grid item>
              <Typography variant="h5" mb={2}>
                {t("global.there_isno_data_newer_24", "There is no data newer than the last 24 hours.")}
              </Typography>
            </Grid>
          ) : (
            <>
              <Grid item>
                <TextCell2
                  label={t("global.table.last_updated", "Last updated")}
                  text={`${moment(iotResult.data.ioTLatestUpdated).format("YYYY-MM-DD HH:mm")}`}
                />
              </Grid>
              <Grid item>
                <TextCell2
                  label={t("global.meter_setting", "Meter setting")}
                  text={
                    iotResult.data.ioTOdometer &&
                    `${Math.trunc(iotResult.data.ioTOdometer)} ${t("global.km", "km")}`
                  }
                />
              </Grid>
              <Grid item>
                <TextCell2
                  label={t("vehicleregistry.fuel_level", "Fuel level")}
                  text={iotResult.data.ioTFuelLevel && `${iotResult.data.ioTFuelLevel} %`}
                />
              </Grid>
              {iotResult.data.ioTVehicleTemperature && (
                <Grid item>
                  <TextCell2
                    label={t("vehicleregistry.temperature_in_vehicle", "Temperature in vehicle")}
                    text={`${Math.trunc(iotResult.data.ioTVehicleTemperature)} °C`}
                  />
                </Grid>
              )}
              {iotResult.data.ioTDistanceToService && (
                <Grid item>
                  <TextCell2
                    label={t("vehicleregistry.distance_to_service", "Distance to service")}
                    text={`${iotResult.data.ioTDistanceToService} ${t("global.km", "km")}`}
                  />
                </Grid>
              )}
              {iotResult.data.ioTTimeToService && (
                <Grid item>
                  <TextCell2
                    label={t("vehicleregistry.time_to_service", "Time to service")}
                    text={`${iotResult.data.ioTTimeToService} ${t("global.days", "Days")}`}
                  />
                </Grid>
              )}
              {iotResult.data.ioTDistanceToOilService && (
                <Grid item>
                  <TextCell2
                    label={t("vehicleregistry.distance_to_oil_service", "Distance to oil service")}
                    text={`${iotResult.data.ioTDistanceToOilService} ${t("global.km", "km")}`}
                  />
                </Grid>
              )}
              {iotResult.data.ioTTimeToOilService && (
                <Grid item>
                  <TextCell2
                    label={t("vehicleregistry.time_to_oil_service", "Time to oil service")}
                    text={`${iotResult.data.ioTTimeToOilService} ${t("global.days", "Days")}`}
                  />
                </Grid>
              )}
            </>
          )}
        </Grid>
      </Box>
    )
  )
}

export default IoTInfo
